import { render, staticRenderFns } from "./CardLadder.vue?vue&type=template&id=8a1e637a&scoped=true&"
import script from "./CardLadder.vue?vue&type=script&lang=js&"
export * from "./CardLadder.vue?vue&type=script&lang=js&"
import style0 from "./CardLadder.vue?vue&type=style&index=0&id=8a1e637a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1e637a",
  null
  
)

export default component.exports